import { AppBar, Button, Toolbar, useMediaQuery, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';

import styles from './app-header.module.scss';

type HeaderProps = { loginDestination: string };

export function AppHeader(props: HeaderProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <AppBar position="static" color="default" elevation={1}>
      <Toolbar sx={{ display: "flex", justifyContent: "space-between", padding: isMobile ? '0.5rem' : '0.75rem' }}>
        {/* Left Side: Mojang Logo */}
        <Link to="/">
          <img
            src="/MOJ_PREM_Redbox_RGB.png"
            alt="Mojang Studios"
            style={{
              height: isMobile ? "24px" : "30px",
              marginRight: isMobile ? "8px" : "10px"
            }}
          />
        </Link>

        {/* Right Side: Log In */}
        {props.loginDestination &&
          <Link to={props.loginDestination} className={styles['login']}>
            Log In
          </Link>
        }
      </Toolbar>
    </AppBar>
  );
}
